import { render, staticRenderFns } from "./CustomerExchangeBanks.vue?vue&type=template&id=7df5fd7b"
import script from "./CustomerExchangeBanks.vue?vue&type=script&lang=js"
export * from "./CustomerExchangeBanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports